import React, {useEffect, useRef, useState} from "react";
import { FeaturedJobsContext } from '../../context';
import classes from "./FeaturedJobs.module.scss";
import { getTagsData, searchClient, urlToObject } from "../../helpers/search";
import {
  Configure,
  Hits,
  InstantSearch,
  RefinementList,
  SearchBox,
} from "react-instantsearch";
import { Button } from "../Button/Button";
import { Hit } from "../Hit/Hit";
import { Results } from "../Results/Results";
import { LocationState } from "../../@types/search";
import { IJobsSearchFeaturedJobsWidgetFields } from "../../@types/contentful";
import { useLocation } from "react-router-dom";
import { QuickPagination } from "../QuickPagination/QuickPagination";
import { scrollToStart } from "../../helpers/scrollTo";
interface Props {
  contentfulData: IJobsSearchFeaturedJobsWidgetFields;
}

export const FeaturedJobs: React.FC<Props> = ({ contentfulData }) => {
  const location = useLocation<LocationState>();
  const jobsRef = useRef<HTMLDivElement>(null);
  const algoliaIndex = process.env.REACT_APP_ALGOLIA_INDICES_BY_DATE;

  const scrollTo = () => {
    scrollToStart(jobsRef);
  };

  useEffect(() => {
    if (location.state?.goBack) {
      setTimeout(() => {
        scrollTo();
      }, 100);
    }
  }, [location.state]);

  const [numberOfHits, setNumberOfHits] = useState<number>(0);

  const meta = Array.prototype.slice.call(
    document.querySelectorAll("meta")
  ) as HTMLMetaElement[];
  const searchData = getTagsData(meta);
  const defaultSearchState = {
    ...urlToObject(location),
    query: searchData?.query ? searchData.query : "",
    refinementList: {
      group: [searchData?.group ? searchData.group : ""],
      country: [searchData?.country ? searchData.country : ""],
    },
  };

  return (
    <div ref={jobsRef} className={classes.featuredJobs}>
      <InstantSearch
        searchClient={searchClient}
        indexName={algoliaIndex}
        initialUiState={{
          [algoliaIndex]: defaultSearchState || {},
        }}
        routing={true}
      >
        <Configure filters="type: Professionals" hitsPerPage={3} />

        <div className={classes.featuredJobsDefaultSearchBox}>
          <SearchBox />
        </div>
        <div className={classes.featuredJobsRefinement}>
          <RefinementList attribute="country" />
          <RefinementList attribute="group" />
        </div>
        <div className={classes.featuredJobsResultsWrapper}>
          {numberOfHits === 0 && (
            <div className={classes.featuredJobsNoResults}>
              {contentfulData?.noResults}
            </div>
          )}
          <FeaturedJobsContext.Provider
            //@ts-ignore TODO: Fix this
            value={{ postedDatesSchema: contentfulData?.postingDate.fields }}
          >
            <Results isQuickJobs setNumber={setNumberOfHits} visibleHits={3}>
              <Hits hitComponent={Hit} />
            </Results>
          </FeaturedJobsContext.Provider>
        </div>
        <QuickPagination
          scrollToStart={scrollTo}
          numberOfHits={numberOfHits}
          showNextText={contentfulData?.showNextJobsButton}
          showPreviousText={contentfulData?.showPreviousJobsButton}
          className={classes.featuredJobsShowNext}
        >
          {contentfulData?.showNextJobsButton}
        </QuickPagination>
      </InstantSearch>
      <Button
        rounded
        style={{ display: "inline-block" }}
        href={contentfulData?.seeAllAvailableJobsUrl}
        variant="link"
      >
        {contentfulData?.seeAllAvailableJobsButton}
      </Button>
    </div>
  );
};
